export default __webpack_public_path__ + "static/media/loader.cb770f5f.png";